<template>
  <div>
    <b-row
      :style="{
        cursor: condition ? 'not-allowed' : 'unset',
      }"
    >
      <b-col
        :style="{
          pointerEvents: condition ? 'none' : 'unset',
        }"
      >
        <b-overlay variant="light" opacity="0.3" :show="condition" rounded="sm">
          <!-- !!!: v-slot:lock-overlay-content -->
          <slot name="lock-overlay-content" />

          <template v-slot:overlay>
            <div class="text-center">
              <font-awesome-icon icon="lock" size="4x" class="text-secondary opacity-1" />
            </div>
          </template>
        </b-overlay>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    condition: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
